import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";

import Gallery from "../blocks/gallery/Gallery";
import PageTitlePortfolio from "../blocks/page-title/PageTitlePortfolio";

const Portfolio = () => {
  document.body.className = "";
  document.body.classList.add("archive");

  return (
    <Fragment>
      <Helmet>
        <meta charSet="UTF-8" />
        <title>Portfolio | Wedding City Australia</title>

        <meta httpEquiv="x-ua-compatible" content="ie=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="description" content="" />
        <meta name="keywords" content="" />
        <meta name="robots" content="index, follow, noodp" />
        <meta name="googlebot" content="index, follow" />
        <meta name="google" content="notranslate" />
        <meta name="format-detection" content="telephone=no" />
      </Helmet>

      <main id="main" className="site-main">
        <PageTitlePortfolio />

        <div id="page-content" className="spacer p-top-xl">
          <div className="wrapper">
            <Gallery showFull={true} />
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default Portfolio;
